export const categories = [
  {
    slug: 'gaoxiao-shipin',
    name: '搞笑视频',
    icon: 'ri-vidicon-line',
    description: '全网最搞笑的视频合集，笑到停不下来',
    color: 'accent',
  },
  {
    slug: 'gaoxiao-duanzi',
    name: '搞笑段子',
    icon: 'ri-chat-smile-2-line',
    description: '精选神级段子，每天笑出腹肌',
    color: 'primary',
  },
  {
    slug: 'biaoqingbao',
    name: '表情包',
    icon: 'ri-emotion-laugh-line',
    description: '最新最火表情包，斗图必备神器',
    color: 'accent',
  },
  {
    slug: 'shenpinglun',
    name: '神评论',
    icon: 'ri-message-2-line',
    description: '评论区出人才，句句都是经典',
    color: 'secondary',
  },
  {
    slug: 'qipa-shijian',
    name: '奇葩事件',
    icon: 'ri-lightbulb-flash-line',
    description: '世界之大无奇不有，看完怀疑人生',
    color: 'primary',
  },
  {
    slug: 'shadiao-shunjian',
    name: '沙雕瞬间',
    icon: 'ri-emotion-line',
    description: '沙雕网友欢乐多，每日一笑',
    color: 'accent',
  },
];

export const articles = [
  {
    id: 'top10-gaoxiao-shipin-2026-08',
    slug: 'top10-gaoxiao-shipin-2026-08',
    title: '2026年8月最搞笑视频TOP10：第三个笑到我差点叫救护车',
    category: 'gaoxiao-shipin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20colorful%20playful%20collage%20of%20funny%20viral%20video%20thumbnails%20with%20comedy%20elements%20like%20funny%20animals%20silly%20faces%20and%20hilarious%20pranks%20bright%20vibrant%20colors%20playful%20design%20energetic%20mood%20clean%20light%20background%20with%20warm%20yellow%20and%20orange%20accents&width=800&height=450&seq=funny-video-cover-01&orientation=landscape',
    excerpt: '本期榜单收录了全网播放量最高的搞笑视频，从萌宠翻车到人类迷惑行为，每一帧都是快乐源泉。特别推荐第三名，那个老奶奶跳街舞的画面我能看一百遍！',
    content: '',
    rank: 1,
    publishDate: '2026-08-05',
    viewCount: 1280000,
    commentCount: 3600,
    tag: '热门',
  },
  {
    id: 'top10-gaoxiao-duanzi-2026-08',
    slug: 'top10-gaoxiao-duanzi-2026-08',
    title: '笑到肚子疼！2026年8月最搞笑段子TOP10排行榜',
    category: 'gaoxiao-duanzi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20creative%20illustration%20of%20floating%20comedy%20text%20bubbles%20and%20laughing%20elements%20surrounded%20by%20warm%20vibrant%20yellow%20and%20coral%20gradients%20clean%20minimal%20design%20with%20playful%20typography%20light%20background%20joyful%20atmosphere%20modern%20flat%20illustration%20style&width=800&height=450&seq=funny-joke-cover-02&orientation=landscape',
    excerpt: '八月最强段子合集来袭！从神转折笑话到年度最离谱回复，看完不笑算我输。本期竞争激烈，每个段子都堪称经典，建议不要在喝水的时候看。',
    content: '',
    rank: 1,
    publishDate: '2026-08-04',
    viewCount: 980000,
    commentCount: 4200,
    tag: '热榜',
  },
  {
    id: 'top10-biaoqingbao-2026-08',
    slug: 'top10-biaoqingbao-2026-08',
    title: '斗图必备！2026年8月最火表情包TOP10排行榜',
    category: 'biaoqingbao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20grid%20layout%20of%20colorful%20funny%20meme%20style%20illustrations%20with%20exaggerated%20facial%20expressions%20and%20humorous%20Chinese%20text%20overlays%20vibrant%20warm%20background%20with%20orange%20and%20pink%20accents%20playful%20design%20modern%20aesthetic&width=800&height=450&seq=funny-meme-cover-03&orientation=landscape',
    excerpt: '本月表情包江湖风起云涌，新老表情包同台竞技。谁能成为新的斗图之王？本期带你盘点那些刷爆朋友圈的表情包，存下来就对了！',
    content: '',
    rank: 1,
    publishDate: '2026-08-03',
    viewCount: 1560000,
    commentCount: 5800,
    tag: '爆款',
  },
  {
    id: 'top10-shenpinglun-2026-08',
    slug: 'top10-shenpinglun-2026-08',
    title: '评论区出人才！全网最搞笑神评论TOP10合集',
    category: 'shenpinglun',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20social%20media%20comment%20section%20with%20glowing%20hilarious%20comment%20threads%20floating%20upward%20in%20a%20warm%20cozy%20orange%20and%20yellow%20color%20palette%20clean%20modern%20design%20with%20subtle%20gradient%20background%20playful%20atmosphere&width=800&height=450&seq=funny-comment-cover-04&orientation=landscape',
    excerpt: '俗话说得好，自古评论出人才。本期汇总了各大平台评论区里那些让人笑到岔气的神回复。网友的才华果然是无限的，每一句都值得截图保存。',
    content: '',
    rank: 1,
    publishDate: '2026-08-02',
    viewCount: 890000,
    commentCount: 3100,
    tag: '精华',
  },
  {
    id: 'top10-qipa-shijian-2026-08',
    slug: 'top10-qipa-shijian-2026-08',
    title: '离谱到家！8月最奇葩搞笑事件TOP10，看完怀疑人生',
    category: 'qipa-shijian',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20bizarre%20and%20unusual%20objects%20and%20scenes%20arranged%20in%20a%20whimsical%20composition%20with%20warm%20peach%20and%20golden%20color%20tones%20clean%20light%20background%20modern%20flat%20design%20style%20with%20humorous%20elements%20scattered%20playfully&width=800&height=450&seq=funny-weird-cover-05&orientation=landscape',
    excerpt: '世界之大，无奇不有。本期盘点那些真实发生的、让人哭笑不得的奇葩事件。从外卖备注神操作到小区业主群年度大戏，每一件都离谱到让人怀疑是段子。',
    content: '',
    rank: 1,
    publishDate: '2026-08-01',
    viewCount: 1120000,
    commentCount: 4500,
    tag: '精选',
  },
  {
    id: 'top10-shadiao-shunjian-2026-08',
    slug: 'top10-shadiao-shunjian-2026-08',
    title: '今日份快乐源泉！年度沙雕瞬间TOP10，笑到头掉',
    category: 'shadiao-shunjian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20whimsical%20illustration%20of%20silly%20and%20goofy%20moments%20with%20cartoonish%20elements%20like%20funny%20animals%20and%20silly%20human%20poses%20in%20a%20bright%20warm%20coral%20and%20yellow%20color%20scheme%20clean%20airy%20composition%20modern%20illustration%20style%20playful%20mood&width=800&height=450&seq=funny-silly-cover-06&orientation=landscape',
    excerpt: '沙雕网友们又贡献了一波名场面！从地铁上的迷惑行为到办公室的搞笑翻车，生活处处是舞台。看看这期榜单，保证让你笑出眼泪。',
    content: '',
    rank: 1,
    publishDate: '2026-07-31',
    viewCount: 1450000,
    commentCount: 5200,
    tag: '热门',
  },
  {
    id: 'top10-gaoxiao-shipin-2026-07',
    slug: 'top10-gaoxiao-shipin-2026-07',
    title: '7月搞笑视频终极盘点：排行榜前十名笑点密集到窒息',
    category: 'gaoxiao-shipin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20collage%20of%20funny%20video%20screenshots%20featuring%20hilarious%20animal%20fails%20and%20comedy%20reaction%20faces%20with%20a%20warm%20golden%20orange%20color%20palette%20clean%20minimal%20layout%20energetic%20feel%20modern%20design%20with%20playful%20accents&width=800&height=450&seq=funny-video-cover-07&orientation=landscape',
    excerpt: '7月搞笑视频回顾特辑！从萌宠翻车合集到人类幼崽迷惑行为大赏，这个月的好笑程度又创新高。一起回顾那些让人笑到肚子疼的经典瞬间吧！',
    content: '',
    rank: 2,
    publishDate: '2026-07-28',
    viewCount: 1050000,
    commentCount: 2900,
    tag: '回顾',
  },
  {
    id: 'top10-gaoxiao-duanzi-2026-07',
    slug: 'top10-gaoxiao-duanzi-2026-07',
    title: '七月笑料大赏！全网最搞笑段子TOP10，一个比一个绝',
    category: 'gaoxiao-duanzi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20creative%20layout%20of%20playful%20typography%20and%20comedic%20illustration%20elements%20with%20warm%20peach%20and%20amber%20color%20tones%20clean%20white%20background%20modern%20graphic%20design%20style%20featuring%20laughing%20emoji-like%20abstract%20shapes%20joyful%20atmosphere&width=800&height=450&seq=funny-joke-cover-08&orientation=landscape',
    excerpt: '七月段子圈卷出新高度！从社交平台神回复到脱口秀金句，这个月的笑料密度超乎想象。熬夜整理完毕，不笑算我输系列。',
    content: '',
    rank: 2,
    publishDate: '2026-07-25',
    viewCount: 870000,
    commentCount: 3300,
    tag: '',
  },
  {
    id: 'top10-biaoqingbao-2026-07',
    slug: 'top10-biaoqingbao-2026-07',
    title: '存图预警！7月最火表情包TOP10，斗图绝对不会输',
    category: 'biaoqingbao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mosaic%20style%20arrangement%20of%20funny%20expressive%20illustrated%20faces%20and%20Chinese%20internet%20slang%20text%20boxes%20in%20a%20warm%20orange%20and%20coral%20color%20palette%20clean%20minimal%20background%20modern%20flat%20design%20playful%20vibe&width=800&height=450&seq=funny-meme-cover-09&orientation=landscape',
    excerpt: '七月表情包市场行情来了！新晋顶流表情包强势上榜，老牌经典不甘示弱。给你整理了最全最新的表情包库存，斗图群里的MVP就是你。',
    content: '',
    rank: 2,
    publishDate: '2026-07-22',
    viewCount: 1320000,
    commentCount: 4700,
    tag: '精华',
  },
  {
    id: 'top10-shenpinglun-2026-07',
    slug: 'top10-shenpinglun-2026-07',
    title: '嘴替天花板！7月全网神评论TOP10，句句扎心又好笑',
    category: 'shenpinglun',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20elegant%20illustration%20of%20glowing%20social%20media%20comment%20cards%20floating%20in%20a%20warm%20golden%20light%20with%20Chinese%20text%20elements%20clean%20airy%20composition%20modern%20design%20with%20coral%20and%20amber%20accents%20sophisticated%20yet%20playful%20atmosphere&width=800&height=450&seq=funny-comment-cover-10&orientation=landscape',
    excerpt: '七月神评论盘点：那些让人拍案叫绝的评论区金句又来了！从微博到小红书，从B站到知乎，各大平台的网友们用才华证明了什么叫"评论比正文精彩"。',
    content: '',
    rank: 2,
    publishDate: '2026-07-20',
    viewCount: 760000,
    commentCount: 2800,
    tag: '',
  },
  {
    id: 'top10-qipa-shijian-2026-07',
    slug: 'top10-qipa-shijian-2026-07',
    title: '离离原上谱！7月搞笑奇葩事件TOP10，越看越上头',
    category: 'qipa-shijian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20quirky%20illustration%20of%20strange%20and%20unexpected%20scenes%20with%20humorous%20twists%20in%20a%20warm%20peach%20and%20golden%20color%20palette%20clean%20minimal%20design%20modern%20flat%20illustration%20style%20light%20airy%20background%20playful%20whimsical%20mood&width=800&height=450&seq=funny-weird-cover-11&orientation=landscape',
    excerpt: '七月奇葩事件速递！快递小哥的逆天备注、业主群里的年度巨制、还有那些让人怀疑人生的社会新闻。准备好你的三观，因为看完可能就碎了一地。',
    content: '',
    rank: 2,
    publishDate: '2026-07-18',
    viewCount: 980000,
    commentCount: 3900,
    tag: '精选',
  },
  {
    id: 'top10-shadiao-shunjian-2026-07',
    slug: 'top10-shadiao-shunjian-2026-07',
    title: '打工人的快乐源泉！7月沙雕瞬间TOP10治愈你的不开心',
    category: 'shadiao-shunjian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20delightful%20illustration%20of%20playful%20and%20silly%20office%20and%20daily%20life%20moments%20with%20warm%20coral%20and%20amber%20color%20tones%20clean%20modern%20design%20light%20background%20with%20subtle%20gradients%20joyful%20and%20energetic%20atmosphere%20flat%20illustration%20style&width=800&height=450&seq=funny-silly-cover-12&orientation=landscape',
    excerpt: '七月沙雕合集来了！打工人的快乐就是这么简单——地铁上的神巧合、办公室的迷惑操作，还有那些让人笑出猪叫的日常。每天看一遍，烦恼全不见。',
    content: '',
    rank: 2,
    publishDate: '2026-07-15',
    viewCount: 1180000,
    commentCount: 4100,
    tag: '热门',
  },
];

export const articleContent: Record<string, {
  summary: string;
  items: Array<{ rank: number; title: string; description: string; image?: string }>;
  conclusion: string;
}> = {
  'top10-gaoxiao-shipin-2026-08': {
    summary: '本期搞笑视频排行榜竞争异常激烈！经过了上千万网友的观看和投票，我们精选出了本月最好笑的十个视频。从萌宠翻车到人类迷惑行为，从街头神巧合到家庭欢乐日常，每一个都是经过验证的快乐源泉。话不多说，直接上榜单！',
    items: [
      { rank: 1, title: '当猫主子第一次照镜子', description: '一只橘猫对着镜子里的自己炸毛了整整三分钟，期间还试图绕到镜子后面找"那只猫"算账。网友评论："猫：这是谁？怎么这么帅？不对，太帅了一定是敌人！"该视频在各大平台累计播放量超过5000万，评论区笑点密集到需要暂停缓一缓。' },
      { rank: 2, title: '外卖小哥的神级躲避', description: '一只突然冲出来的流浪狗追着外卖小哥跑了两条街，小哥一路蛇形走位外加翻越两个花坛，手里的外卖居然一滴没洒。最后狗狗累趴了，小哥淡定地说了句"您的餐到了"。这个视频让全国外卖小哥的战斗力得到了重新评估。' },
      { rank: 3, title: '78岁奶奶跳街舞', description: '一位78岁的奶奶在广场舞间隙展示了一段即兴街舞，动作包括但不限于：地板动作、头转（虽然只转了半圈）、以及一个让全场尖叫的定格pose。视频火到国外，被外媒称为"中国最酷奶奶"。奶奶接受采访时说："我就是想试试看我还能不能动。"' },
      { rank: 4, title: '婚礼上的意外伴郎', description: '一场婚礼上，新娘养的金毛突然冲上舞台叼走了戒指盒，然后在全场200多人的注视下，把戒指盒放在了新郎脚下并蹲下"握手"。新郎当场感动落泪，宾客们笑声不断。该视频被各大萌宠博主疯狂转发，被誉为"年度最暖婚礼名场面"。' },
      { rank: 5, title: '爸爸带娃的后果', description: '一位爸爸独自带娃一天，结果把孩子的裤子穿反了、奶粉冲成了面糊、还把孩子哄睡后自己先睡着了。妈妈回家后拍下了"案发现场"，视频中爸爸和孩子一起躺在沙发上，周围散落着玩具和零食，画面温馨又好笑。评论区："能活着就很不错了"。' },
      { rank: 6, title: '地铁上的灵魂歌手', description: '一位大哥在地铁上用手机外放唱歌，唱的是《死了都要爱》，全程高音破音却异常投入。整个车厢的人先是震惊，然后纷纷掏出手机拍摄。最搞笑的是，下车时还有人喊"再来一首"。大哥羞涩地摆摆手说"下次下次"。' },
      { rank: 7, title: '考试前的绝望', description: '一名大学生在期末考试前一天的图书馆里，对着厚厚的教材崩溃大哭。室友拍下了全过程，包括他从哭到笑再到默默翻开第一页的完整情绪变化。网友纷纷表示"这就是我"，该视频在考试季被奉为"考前必看解压神器"。' },
      { rank: 8, title: '健身房的迷惑行为', description: '健身房监控拍下了一位大哥的奇特健身方式：用跑步机擦玻璃、用哑铃当擀面杖、还在瑜伽垫上睡着了。健身教练在评论区留言："我已经通知所有门店加强巡视了。"网友："这不是健身，这是行为艺术。"' },
      { rank: 9, title: '猫咪的数学天赋', description: '一只猫咪被主人训练做算术题，每次主人说"1+1等于几"，猫就会叫两声。但视频后半段真相揭晓——猫只是对主人的手势起了反应，让做什么就做什么。网友："我还以为我家的猫是学渣，原来大家都是学渣。"' },
      { rank: 10, title: '超市里的意外邂逅', description: '两个多年未见的老同学在超市偶遇，激动地拥抱时不小心撞翻了旁边的货架。泡面散落一地，两人一边捡一边笑，最后干脆坐在地上聊了半小时。店员无奈地表示："我们已经习惯了，这个货架每个月至少要倒一次。"' },
    ],
    conclusion: '以上就是2026年8月搞笑视频TOP10的全部内容！每一个都是真实发生、让人笑到停不下来的精彩瞬间。如果你也有搞笑的视频想分享，欢迎给我们投稿。下期榜单，我们不见不散！记得收藏这个页面，不开心的时候回来看看，保证治愈你的坏心情。',
  },
};

export const testimonials = [
  {
    name: '打工是不可能打工的',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20Chinese%20person%20with%20a%20warm%20smile%20minimal%20style%20clean%20light%20background%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '每天早上坐地铁第一件事就是打开搞笑排行榜，看完再上班心情好一天！推荐给全公司了，现在茶水间讨论的都是昨天的榜单内容。真·摸鱼神器！',
    date: '2026-08-03',
  },
  {
    name: '今天也不想上班',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20woman%20with%20a%20bright%20smile%20minimal%20style%20clean%20light%20background%20friendly%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '笑死我了哈哈哈哈！那个神评论合集我看了至少三遍，每次都能发现新的笑点。比刷短视频有意思多了，起码不会不知不觉刷掉两个小时。',
    date: '2026-08-01',
  },
  {
    name: '摸鱼协会会长',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20man%20with%20glasses%20and%20a%20grin%20minimal%20style%20clean%20light%20background%20friendly%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '作为一个资深的搞笑内容爱好者，我可以负责任地说：这个网站的榜单质量是真的高。不搬运、不洗稿，每个榜单都能看出编辑是真的花了心思在整理的。',
    date: '2026-07-28',
  },
  {
    name: '笑点很低星人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20woman%20with%20long%20hair%20and%20a%20laughing%20expression%20minimal%20style%20clean%20light%20background%20friendly%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '表情包排行榜是我最爱的栏目！每次更新必存，现在我的微信表情包库存已经爆满了。同事都说我是斗图无敌手，全靠搞笑排行榜的每日更新！',
    date: '2026-07-25',
  },
  {
    name: '深夜不睡选手',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20man%20with%20a%20sleepy%20but%20happy%20face%20minimal%20style%20clean%20light%20background%20friendly%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '凌晨两点被奇葩事件那个榜单笑得全宿舍都醒了，室友差点把我赶出去。但是他们也忍不住过来一起看，最后变成了宿舍深夜搞笑观影会。感谢搞笑排行榜！',
    date: '2026-07-20',
  },
  {
    name: '斗图界扛把子',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cartoon%20avatar%20of%20a%20young%20person%20with%20a%20cool%20confident%20smile%20minimal%20style%20clean%20light%20background%20friendly%20expression&width=80&height=80&seq=avatar-06&orientation=squarish',
    content: '每天更新真的牛！别的网站一周更一次还经常水，你们每天都有高质量新内容。段子排行榜我已经连续追了三个月了，一期都没落下。希望你们越做越好！',
    date: '2026-07-18',
  },
];